
// 要在父级组件的根节点 触发 this.$store.dispatch('orderUser/getUserInfo')

import { getUserInfo } from '@@/api/center'

const state = {
  userInfo: {},
  isLogin: false
}

const getters = {
  userInfo(state) {
    return state.userInfo
  },
  isLogin(state) {
    return state.isLogin
  }
}

const mutations = {
  setUserInfo(state, info) {
    state.userInfo = info
  },
  setIsLogin(state, isLogin) {
    state.isLogin = isLogin
  }
}

const actions = {
  async getUserInfo({ commit }) {
    const res = await getUserInfo({})
    if (res && res.retCode == 0) {
      commit('setUserInfo', res.result || {})
      commit('setIsLogin', !!(res.result || {}).sso_uid)
    } else {
      commit('setUserInfo', {})
      // commit('setIsLogin', false)
      commit('setIsLogin', process.env.NODE_ENV === 'development')
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}